import React from 'react'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'

export const center = css`
  position: fixed;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
`

export default function LoadingSpinner() {
  return (
    <div data-testid="loading-spinner" className={center}>
      <NoticeLoading size="lg" />
    </div>
  )
}
